import { ViewController, ModelUpdateEvent, DomInstantiateEvent, TimeoutEvent, Phase } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";
import { ChunkPickEvent } from "../../Event/ChunkPickEvent";
import { ChunkAreaView } from "../../View/ChunkAreaView";
import { ChunkPickerViewController } from "./ChunkPickerViewController";
import { CallToActionViewController } from "./CallToActionViewController";
import { Chunk } from "../../Data/Chunk";
import { CHUNK_MODEL_CHUNK } from "../../Model/ChunkModel";


export class ChunkAreaViewController extends ViewController {
    chunkAreaView: ChunkAreaView;
    chunkPickerViewController: ChunkPickerViewController;
    callToActionViewController: CallToActionViewController;
    isOnAutopilot:boolean;

    postMatchDelayInS:number;

    constructor( options ) {
        options = options || {};
        options.view = options.chunkAreaView ||null;
        options.name = options.name || 'chunkAreaViewController';

        options.eventsToSubscribe = [
            {
                eventType: ModelUpdateEvent,
                provider: app.customerIntegrationController
            },
            {
                eventType: ChunkRangeChangeEvent,
                provider: app.timelineController
            }
        ];

        super( options );
        this.chunkAreaView = options.chunkAreaView || options.view ||null;

        this.chunkAreaView.addSubscriberForEvent( this, DomInstantiateEvent );

        this.isOnAutopilot = true;

        this.postMatchDelayInS = srvg.config.workaround_delay_post_match_seconds;

        this.generatedEvents.push( ChunkChangeEvent );
        this.generatedEvents.push( ChunkRangeChangeEvent );

        /******************* initialize controllers ************************/


        this.chunkPickerViewController = null;
        // todo move to handle dominiated event, see below
        if( this.chunkAreaView.chunkPickerView ) {
            this.chunkPickerViewController = this.addChildViewController( new ChunkPickerViewController( {
                chunkPickerView: this.chunkAreaView.chunkPickerView,
                chunkModel: this.chunkAreaView.selectedChunkModel
            } ) );
        }

        this.callToActionViewController = this.addChildViewController( new CallToActionViewController( {
            callToActionView: this.chunkAreaView.callToActionView,
            chunkModel: this.chunkAreaView.selectedChunkModel
        }) );

        /*
        if( this.chunkAreaView.oddsFrame ) {
            this.oddsFrameViewController = this.addChildViewController( new OddsFrameViewController( {
                oddsFrame: this.matchdayArea.oddsFrame,
                channel: srvg.videooptions.defaultchannel || 0
            } ) );
        }
        else {
            this.oddsFrameViewController = null;
        }
        */

        /******************* connect components ************************/

        app.timelineController.addSubscriberForEvent( this, PhaseChangeEvent );
        this.chunkAreaView.selectedChunkModel.addSubscriberForEvent( this, ModelUpdateEvent );

        if( this.chunkPickerViewController ) {
            app.customerIntegrationController.addSubscriberForEvent( this, ChunkPickEvent );
            this.chunkPickerViewController.addSubscriberForEvent( this, ChunkPickEvent );
            this.chunkPickerViewController.addSubscriberForEvent( this, PhaseChangeEvent );
            this.addSubscriberForEvent( this.chunkPickerViewController, ChunkChangeEvent );
            this.addSubscriberForEvent( this.callToActionViewController, ChunkChangeEvent );
            this.addSubscriberForEvent( this.chunkPickerViewController, ChunkRangeChangeEvent );
        }

        if( app.inactivityController ) {
            app.inactivityController.addSubscriberForEvent( this.callToActionViewController, TimeoutEvent );
        }
        /*
         if( this.oddsFrameViewController ) {
            this.matchdayArea.matchdayAreaModel.addSubscriberForEvent( this.oddsFrameViewController, ModelUpdateEvent );
            this.oddsViewController.oddsView.addSubscriberForEvent( this.oddsFrameViewController, SelectionUpdateEvent );
         }
         */
    }

    private autoSelectChunk(  currentChunk: Chunk, currentPhase: Phase ) {
        // calculate selected chunk
        var chunk = currentChunk;
        // console.log( 'updateAutoSelectedChunk', currentChunk );

        // betstop passed?
        if( currentPhase.shouldSwitchToNextChunk() ) {
            if( chunk.next ) {
                chunk = chunk.next;
            }
        }
        // adjust for offset of this matchday area
        for( var i = 0; i < this.chunkAreaView.offset; i++ ) {
            if( chunk.next ) {
                chunk = chunk.next;
            }
        }
        return chunk;
    }

    private updateAutoSelectedChunk( chunk: Chunk ) {
        // update selected matchday in model
        if( ! chunk.isEqualTo( this.chunkAreaView.selectedChunkModel.chunk ) ) {
            this.chunkAreaView.selectedChunkModel.setChunk(chunk );
        }
    }

    private shouldSwitchToAutopilot( currentChunk: Chunk, currentPhase: Phase ): boolean {
        var selectedChunk = this.chunkAreaView.selectedChunkModel;

        // if not on autopilot, but selected matchday is either the current matchday or in the past, and the betstop phase just started, turn autopilot on
        if(!this.isOnAutopilot
            && (selectedChunk.chunk)
            && (selectedChunk.chunk.start <= currentChunk.start)
            && (srvg.config.switch_to_autopilot_phases.indexOf(app.timeline.currentPhaseModel.phase.name) != -1)) {
            // console.log( 'Should switch to autopilot: yes; ', currentPhase.name );
            return true;
        }
        // to ensure that the autopilot is on for the switch after knockout stage betstop (in case of manual switches before)
        if(!this.isOnAutopilot
            && ((selectedChunk.chunk.nr == 12) || (selectedChunk.chunk.competitionStageTypeId == 2 && selectedChunk.chunk.nr == 2)
                || (selectedChunk.chunk.competitionStageTypeId == 2 && selectedChunk.chunk.nr == 3)
                || (selectedChunk.chunk.competitionStageTypeId == 2 && selectedChunk.chunk.nr == 4))
            && (!this.chunkPickerViewController.chunkPickerView.nextButton.isEnabled)) {
            // console.log( 'Should switch to autopilot: yes; ', currentPhase.name );
            return true;
        }
        //console.log( 'Should switch to autopilot: no; ', currentPhase.name );
        return false;
    }

    // ************************** Event handlers **************************

    handleDomInstantiateEvent( e ) {
        /*  if( this.chunkAreaView.chunkPickerView ) {
            console.warn('INITIATING SELF-DESTRUCT!');
            this.chunkPickerViewController = this.addChildViewController( new ChunkPickerViewController( {
                chunkPickerView: this.chunkAreaView.chunkPickerView,
                chunkModel: this.chunkAreaView.selectedChunkModel
            } ) );
        }*/
    }

    /**
     *   Called by timeline controller
     */
    handlePhaseChangeEvent( event:PhaseChangeEvent, provider ) {
        if( event.channel == app.timeline.currentChannel ) {
            var chunkModel = this.chunkAreaView.selectedChunkModel;

            var currentChunk = event.chunk;

            if( app.timeline.chunkRangeModel.findChunkIndex( currentChunk ) === null ) {
                // if selected chunk is not in newChunks, select first chunk in chunkRangeModel
                console.log( 'ERROR: current chunk is not in chunk range' );
                currentChunk = app.timeline.chunkRangeModel.getChunk( 0 );
            }

            // Forces the View on the new season when the old season is closed
            if(event.phase.name === 'pre_cup') {
                this.triggerEvent( new ChunkChangeEvent(app.timeline.currentChunkModel.chunk) );
            }

            if( this.chunkPickerViewController ) {
                if( !this.isOnAutopilot && this.shouldSwitchToAutopilot( currentChunk, event.phase ) ) {
                    this.isOnAutopilot = true;
                }
            }
            if( this.isOnAutopilot ) {
                var chunk = this.autoSelectChunk( currentChunk, event.phase );
                var now = app.server.getTime();
                /**
                 * Woraround for slow odds creation after match end:
                 * If the new phase is the post_match phase and new chunks were added just now
                 * start of the post_match phase has been over for less than 10s
                 * (meaning we are are going to switch to the next chunk now), delay this call by 10s.
                 */
                if(
                    this.postMatchDelayInS &&
                    event.phase.id == srvg.timelinePhases.post_match.id &&
                    app.timelineController.newChunksInLastData &&
                    event.phase.start+this.postMatchDelayInS > now
                ) {
                    var that = this;
                    // to ensure that the clock doesn't start to early after knockout stage betstop
                    // because it shall start after post match overlay is hidden (delay 3000)
                    if((this.chunkAreaView.selectedChunkModel.chunk != null)
                        && (this.chunkAreaView.selectedChunkModel.chunk.nr == currentChunk.nr)
                        && (!this.chunkPickerViewController.chunkPickerView.nextButton.isEnabled)) {
                        window.setTimeout(
                            function() {
                                that.updateAutoSelectedChunk( chunk );
                                //that.handlePhaseChangeEvent( event, provider);
                            },
                            srvg.config.workaround_delay_post_match_seconds*3000
                        );
                    } else {
                        window.setTimeout(
                            function() {
                                that.updateAutoSelectedChunk( chunk );
                                //that.handlePhaseChangeEvent( event, provider);
                            },
                            srvg.config.workaround_delay_post_match_seconds*1000
                        );
                    }
                    //console.log( 'Delaying chunk picker', event.phase.start, this.postMatchDelayInS, now );

                    return;
                }
                this.updateAutoSelectedChunk( chunk );
            }


        }
    }

    /**
     * Called by chunk picker controller or customer integration controller
     */
    handleChunkPickEvent(event:ChunkPickEvent, provider) {
        var chunk = event.chunk;

        // if selected chunk isn't in the chunkrangemodel, select the first chunk
        if( app.timeline.chunkRangeModel.findChunkIndex( chunk ) === null ) {
            //console.log( 'selected chunk isn\'t in the chunkrangemodel, selecting the first chunk', this.chunkPickerView.selectedChunkModel.chunk, this.chunkPickerView.chunkRangeModel.findChunkIndex( this.chunkPickerView.selectedChunkModel.chunk ) );
            chunk = app.timeline.chunkRangeModel.getChunk( 0 );
        }

        //console.log( 'ChunkAreaViewController.handleChunkPickEvent' );
        if( provider == this.chunkPickerViewController ) {
            // chunk picker was clicked
            this.chunkAreaView.selectedChunkModel.setChunk(chunk );
            this.isOnAutopilot = false;
        }
        else if( provider == app.customerIntegrationController ) {
            // customer-facing API was called
            // select the chunk in the chunkpicker, which will act like it was clicked
            if( this.chunkPickerViewController ) {
                this.chunkPickerViewController.chunkPickerView.pickChunk( chunk );
            }
        }
    }

    /**
     * Called by this.selectedChunkModel
     */
    handleModelUpdateEvent( event:ModelUpdateEvent, provider ) {
        if( event.model == this.chunkAreaView.selectedChunkModel && event.propertyName == CHUNK_MODEL_CHUNK ) {
            this.triggerEvent( new ChunkChangeEvent( event.propertyValue ) );
        }
    }

    /**
     * Called by timelineController
     */
    handleChunkRangeChangeEvent( event:ChunkRangeChangeEvent, provider ) {
        this.triggerEvent( event );
    }

    // called by desktopviewcontroller for chunkareaview
    handleTimeoutEvent(event, provider) {
        this.chunkAreaView.disable();
    }
}
